import { CanDeactivateFn } from '@angular/router';
import { SurveyDetailComponent } from '../../pages/survey-detail/survey-detail.component';

export const surveyDetailCanDeactivateGuard: CanDeactivateFn<SurveyDetailComponent> = (component) => {
    return component.canDeactivateWithConfirm();
};
